import { useQuery } from '@apollo/client';
import { GET_VARIABILITY_FACTORS, GET_AVERAGE_ANNUAL_DEMAND_PER_ERC, GET_PEAK_MONTH_AVG_DEMAND } from '../../../queries/engineeringQrys';

/**
 * Data for the DWRi Calculations tab.
 * @param {string} pwsId - The full PWS ID (e.g., "UTAH12345")
 * @param {number[]} years - Array of years to fetch data for
 * @param {string[]} selectedSources - Optional array of selected source IDs
 */
const useDwriCalculationsData = ({ pwsId, years, selectedSources = [] }) => {
    const skipYearBased = !pwsId || years.length === 0;
    const sourceFilter = selectedSources.length > 0 ? selectedSources : undefined;

    const {
        data: variabilityFactorsData,
        loading: variabilityFactorsLoading,
        error: variabilityFactorsError,
        refetch: refetchVariabilityFactors,
    } = useQuery(GET_VARIABILITY_FACTORS, {
        variables: { pwsId, years },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: averageAnnualDemandData,
        loading: averageAnnualDemandLoading,
        error: averageAnnualDemandError,
    } = useQuery(GET_AVERAGE_ANNUAL_DEMAND_PER_ERC, {
        variables: { pwsId, years, sources: sourceFilter },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: peakMonthAvgDemandData,
        loading: peakMonthAvgDemandLoading,
        error: peakMonthAvgDemandError,
    } = useQuery(GET_PEAK_MONTH_AVG_DEMAND, {
        variables: { pwsId, years },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    return {
        variabilityFactors: variabilityFactorsData?.getVariabilityFactors || [],
        refetchVariabilityFactors,
        averageAnnualDemandRows: averageAnnualDemandData?.getAverageAnnualDemandPerErc || [],
        peakMonthAvgDemandRows: peakMonthAvgDemandData?.getPeakMonthAvgDemand || [],
        loading: {
            variabilityFactors: variabilityFactorsLoading,
            averageAnnualDemand: averageAnnualDemandLoading,
            peakMonthAvgDemand: peakMonthAvgDemandLoading,
        },
        errors: {
            variabilityFactors: variabilityFactorsError,
            averageAnnualDemand: averageAnnualDemandError,
            peakMonthAvgDemand: peakMonthAvgDemandError,
        },
    };
};

export default useDwriCalculationsData;
